export default {
  loaderMessageDefault: "Loading...",
  loading: "Loading...",
  uploading: "Uploading...",
  ordering: "ordering...",
  generatingReport: "Generating...",
  processing: "Processing...",
  saving: "Saving...",
  updating: "Updating...",
  restoring: "Restoring...",
  deleting: "Deleting...",
  deletingSelected: "Deleting selected records...",
  deletingSelectedSuccess: "Selected records deleted successfully!",
  deletingPermanently: "Deleting...",
  onPageRecordNumberChange: "Updating...",
  searching: "Searching...",
  searchBtnText: " Search",
  importing: "Importing...",
  exporting: "Exporting...",
  generating: "Generating...",
};